module.exports = __webpack_public_path__ + "img/Cloud-background-left.a6785440.png";